import * as React from 'react';
import styles from './index.less';
import { FI18n } from '@freelog/tools-lib';

function NodeDeleted() {
  return (
    <div className={styles.container}>
      <div className={styles.iconWrapper}>
        <i className={`freelog fl-icon-huodongjieshu ${styles.icon}`} />
      </div>
      <div className={styles.mainText}>
        {FI18n.i18nNext.tAuto('nodemgnt_alarm_deleted_msg')}
      </div>
      <div className={styles.subText}>
        {FI18n.i18nNext.tAuto('nodemgnt_alarm_deleted_msg2')}
      </div>
    </div>
  );
}

export default NodeDeleted;
